import { FC } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  SimpleGrid,
} from '@chakra-ui/react';

type Props = {
  createdAt: string;
};

/**
 * 編集モーダル用の Zeus Token 作成日フォーム(readonly)です。
 */
export const ZeusTokenCreatedAtForm: FC<Props> = ({ createdAt }) => (
  <FormControl>
    <SimpleGrid templateColumns="1fr 2fr">
      <Box pl="40px">
        <FormLabel>- 作成日</FormLabel>
      </Box>
      <Input value={createdAt} disabled />
    </SimpleGrid>
  </FormControl>
);
